import React, { useEffect, useId, useState } from 'react';
import PropTypes from 'prop-types';
import './FacultiesDepartmentsDropdown.css';
import Loading from '../utilities/Loading';
import { Col, Container, Row } from 'react-bootstrap';
import FormElementHeader from './FormElementHeader';
import { useTranslation } from 'react-i18next';
import DropDown from './DropDown';

const fetchFacultiesDepartments = async () => {
  const URL = `${process.env.REACT_APP_LATAAMO_PROXY_SERVER}/api/facultiesDepartments`;
  const response = await fetch(URL);

  if (!response.ok) {
    throw new Error(`Unexpected status code from ${URL}`, {
      cause: { status: response.status }
    });
  }

  return response.json();
};

const isUniversityOfHelsinki = unit => [unit.name_fi, unit.name_en, unit.name_sv]
  .some(name => ['helsingin yliopisto', 'university of helsinki', 'helsingfors universitet']
    .includes(name?.trim().toLocaleLowerCase()));

const FacultiesDepartmentsDropdown = ({ selected, onChange, disabled, message, required}) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [facultiesDepartments, setFacultiesDepartments] = useState([]);
  const id = useId();

  useEffect(() => {
    fetchFacultiesDepartments()
      .then(setFacultiesDepartments)
      .catch(error => console.error(error))
      .finally(() => setLoading(false));
  }, []);

  const language = i18n.language?.split('-')[0] || 'fi';
  const options = [
    { label: t('faculty_department_option_default_select'), value: '' },
    ...facultiesDepartments
      .map(unit => ({
        unit,
        label: unit[`name_${language}`] || unit.name_en || unit.name_fi || unit.name_sv || ''
      }))
      .sort((a, b) => Number(isUniversityOfHelsinki(b.unit)) - Number(isUniversityOfHelsinki(a.unit))
        || a.label.localeCompare(b.label, language))
      .map(({ unit, label }) => ({ label, value: unit.id }))
  ];

  return (
    <Loading loading={loading}>
      <Container className="faculties-departments ps-0">
        <Row>
          <Col>
            <FormElementHeader id={id} required={required}>
              {t('faculty_department_header')}
            </FormElementHeader>
          </Col>
        </Row>
        <Row>
          <Col>
            <DropDown
              aria-labelledby={id}
              options={options}
              message={message}
              value={selected}
              aria-required
              disabled={disabled}
              onChange={e => onChange(e.target.value)} />
          </Col>
        </Row>
      </Container>
    </Loading>
  );
};

FacultiesDepartmentsDropdown.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  message: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['light', 'neutral', 'warning'])
  })
};

export default FacultiesDepartmentsDropdown;
